<h2 mat-dialog-title>{{ data.key }}</h2>
<mat-dialog-content>
  <mat-form-field floatLabel="auto" spellcheck="false">
    <textarea [formControl]="input" matInput cdkTextareaAutosize></textarea>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button type="submit" mat-flat-button color="primary" (click)="save()">Save</button>
</mat-dialog-actions>